// ============================================================
// useDelayedRefresh.js
// Returns schedule(): run `refresh` once after `delayMs`, replacing
// any pending run, cancelled on unmount. Used after an invitation
// resend: ACS accepts the email at once, and a refusal arrives a few
// seconds later via the delivery webhook, so one delayed re-read is
// what makes "Email not delivered" appear without a manual reload.
// ============================================================
import { useCallback, useEffect, useRef } from 'react';

export const DELIVERY_REFRESH_MS = 10000;

export default function useDelayedRefresh(refresh, delayMs = DELIVERY_REFRESH_MS) {
  const timer = useRef(null);
  const latest = useRef(refresh);
  latest.current = refresh;

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  return useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      timer.current = null;
      latest.current();
    }, delayMs);
  }, [delayMs]);
}
